import { Button, Card, CardBody, CardFooter } from '@nextui-org/react'
import React from 'react'
import InlineEditAsalMuat from './InlineEditAsalMuat'
import InlineEditTujuanBongkar from './InlineEditTujuanBongkar'
import { useFieldArray } from 'react-hook-form';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

export default function TransportComponent({ companyId, control, setValue, errors }) {
    const { fields, append, remove } = useFieldArray({ control, name: 'perusahaanAsalMuatDanTujuanBongkar', });
    return (
        <>
            <div className='flex flex-col'>
                <div>
                    <Button className='inline-flex' onClick={() => append({ perusahaanAsalMuat: null, perusahaanTujuanBongkar: [] },)} color="success" startContent={<PlusIcon className="size-4" />}>
                        Tambah Asal Muat dan Tujuan Bongkar
                    </Button>
                </div>
                {errors.perusahaanAsalMuatDanTujuanBongkar && <p className="text-danger text-xs">{errors.perusahaanAsalMuatDanTujuanBongkar.message}</p>}
            </div>
            {fields.map((field, index) => (
                <Card radius='sm' className='my-3' key={index}>
                    <CardBody>
                        <div className='grid grid-cols-1 md:grid-cols-3 gap-3'>
                            <div className='col-span-1'>
                                <InlineEditAsalMuat 
                                    parentIndex={index}
                                    companyId={companyId} 
                                    control={control} 
                                    setValue={setValue} 
                                />
                            </div>
                            <div className='col-span-2'>
                                <InlineEditTujuanBongkar 
                                    parentIndex={index}
                                    companyId={companyId} 
                                    control={control} 
                                    setValue={setValue}
                                />
                            </div>
                            <div>
                            <Button onClick={() => remove(index)} color="danger" startContent={<TrashIcon className="size-4" />}>
                                Hapus
                            </Button>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            ))}
        </>
    )
}
